import {connect} from 'react-redux';
import {CuvetteRack as Component} from './CuvetteRack';
import {
  createCuvetteRack,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("cuvetteRack") &&
     state.notebook.protocolSection.scene.apparatus.cuvetteRack.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.cuvetteRack[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createCuvetteRack: (data)=>{
      dispatch(createCuvetteRack(data))
    },
  };
}

export const CuvetteRack = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
